var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 18H19C18.4477 18 18 18.4477 18 19V20C18 20.5523 18.4477 21 19 21H20C20.5523 21 21 20.5523 21 20V19C21 18.4477 20.5523 18 20 18Z",
    stroke: "#101010",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.5H19C18.4477 10.5 18 10.9477 18 11.5V12.5C18 13.0523 18.4477 13.5 19 13.5H20C20.5523 13.5 21 13.0523 21 12.5V11.5C21 10.9477 20.5523 10.5 20 10.5Z",
    stroke: "#101010",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 3H19C18.4477 3 18 3.44772 18 4V5C18 5.55228 18.4477 6 19 6H20C20.5523 6 21 5.55228 21 5V4C21 3.44772 20.5523 3 20 3Z",
    stroke: "#101010",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 18H11.5C10.9477 18 10.5 18.4477 10.5 19V20C10.5 20.5523 10.9477 21 11.5 21H12.5C13.0523 21 13.5 20.5523 13.5 20V19C13.5 18.4477 13.0523 18 12.5 18Z",
    stroke: "#101010",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10.5H11.5C10.9477 10.5 10.5 10.9477 10.5 11.5V12.5C10.5 13.0523 10.9477 13.5 11.5 13.5H12.5C13.0523 13.5 13.5 13.0523 13.5 12.5V11.5C13.5 10.9477 13.0523 10.5 12.5 10.5Z",
    stroke: "#101010",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3H11.5C10.9477 3 10.5 3.44772 10.5 4V5C10.5 5.55228 10.9477 6 11.5 6H12.5C13.0523 6 13.5 5.55228 13.5 5V4C13.5 3.44772 13.0523 3 12.5 3Z",
    stroke: "#101010",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5 18H4C3.44772 18 3 18.4477 3 19V20C3 20.5523 3.44772 21 4 21H5C5.55228 21 6 20.5523 6 20V19C6 18.4477 5.55228 18 5 18Z",
    stroke: "#101010",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.5H4C3.44772 10.5 3 10.9477 3 11.5V12.5C3 13.0523 3.44772 13.5 4 13.5H5C5.55228 13.5 6 13.0523 6 12.5V11.5C6 10.9477 5.55228 10.5 5 10.5Z",
    stroke: "#101010",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5 3H4C3.44772 3 3 3.44772 3 4V5C3 5.55228 3.44772 6 4 6H5C5.55228 6 6 5.55228 6 5V4C6 3.44772 5.55228 3 5 3Z",
    stroke: "#101010",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.75452fa2bd81238b1fad8aaba77578af.svg";
export { ForwardRef as ReactComponent };